import { createSelector } from '@reduxjs/toolkit';
import { selectRentTime } from './selectRentTime';
import { ERentTime } from '../../../packages/JsonQuery';

const RENTAL_PERIOD_SELECTED_OPTIONS = [ERentTime.FromYear, ERentTime.FewMonths];

export const selectIsRentalPeriodSelected = createSelector(
  selectRentTime,
  rentTime => rentTime !== null && RENTAL_PERIOD_SELECTED_OPTIONS.includes(rentTime),
);
